import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`You can find me on other platforms too: `}<a parentName="p" {...{
        "href": "https://www.linkedin.com/in/mdanilov96/"
      }}>{`LinkedIn`}</a>{`, `}<a parentName="p" {...{
        "href": "https://github.com/KukR1"
      }}>{`GitHub`}</a>{` or just download a copy of my `}<a parentName="p" {...{
        "href": "https://www.cakeresume.com/s--5nFuK1T2ALQ2j9CNLx-gaQ--/nik-danilov"
      }}>{`CV`}</a>{` :)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      